export default {"src":"/_next/static/media/ham.b3e15575.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};